import { render, staticRenderFns } from "./Cobros.vue?vue&type=template&id=0c71e94a&lang=pug"
import script from "./Cobros.vue?vue&type=script&lang=js"
export * from "./Cobros.vue?vue&type=script&lang=js"
import style0 from "./Cobros.vue?vue&type=style&index=0&id=0c71e94a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports